import { Navigate, Outlet, useLocation } from "react-router";

import { BrandLoader } from "@/client/components/brand-loader";
import { CountryPreferenceGate } from "@/client/components/country-preference-gate";
import { NotificationPopupHost } from "@/client/components/notification-popup";
import { PromoLinkClaimer } from "@/client/components/promo-link-claimer";
import { useUser } from "@/client/services/user";
import { Role } from "@reactive-resume/utils";
export const AuthGuard = () => {
  const location = useLocation();
  const redirectTo = location.pathname + location.search;

  const { user, loading } = useUser();

  if (loading) return <BrandLoader fullScreen />;

  if (user)
    return (
      <>
        <Outlet />
        <CountryPreferenceGate user={user} />
        <PromoLinkClaimer user={user} />
        <NotificationPopupHost user={user} />
      </>
    );

  return <Navigate replace to={`/client/auth/login?redirect=${redirectTo}`} />;
};
